import React, { useState, useRef, useEffect } from "react";

import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";

import useMediaQuery from "@mui/material/useMediaQuery";
import StarRating from "./StarRating";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getActiveSale, getSalePriceDisplay } from "../utils/saleUtils";
import SalePriceLabel from "./SalePriceLabel";


const MockupCard = ({
  imageUrl,
  title,
  description,
  price,
  seller,
  col,
  item,
  setBundleListingsId,
  pageName,
  onAddReviewClick,
  onMoveToFolderClick,
  showMoveToFolder = false,
  showRemoveFromFolder = false,
  onRemoveFromFolderClick,
  thumbnails,
}) => {
  const theme = useTheme();
  const { userid, role } = useSelector((state) => state.auth);
  const isAdmin = role === "A";
  
  const simpleThumbnailSrc = item?.use_main_file_as_thumbnail
    ? item?.compressed_file
    : item?.thumbnails?.[0]?.image;

  const featuredThumbnailSrc = item?.use_main_file_as_thumbnail
    ? item?.compressed_file
    : thumbnails?.[0]?.image;


  const thumbnailSrc =
    featuredThumbnailSrc ??
    simpleThumbnailSrc;

  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));


  const hasUserReviewed = !!item?.has_user_reviewed || false;

  const saleInfo = getActiveSale(item);
  const salePrice = getSalePriceDisplay(item?.price, saleInfo);
  // State for managing submenu visibility
  const [showSubMenu, setShowSubMenu] = useState(false);
  const subMenuRef = useRef(null);

  // Close submenu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setShowSubMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`col-lg-${col}  col-6 lg-mb-3 p-1 px-lg-2`}>
      <div
        className="card p-2 shadow  rounded-tr-lg d-flex flex-column h-100"
        style={{
          display: "flex",
        }}
      >
        <div className="listing-img overflow-hidden position-relative rounded-tr-lg">
          {item?.listings_count ? (
            <Link to={`/bundle?id=${item?.id}`} className="card-img-wrapper">
              <img
                src={item?.bundle_thumbnails[0]?.image}
            
                className="card-img-top rounded-tr-lg"
                alt="Product 1"
              />
              {saleInfo.active && saleInfo.percentage != null && !item?.is_free && (
                <div
                  className="position-absolute z-3 text-center fw-bold text-white small"
                  style={{
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#C93312",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontSize: "12px",
                  }}
                >
                  Sale {saleInfo.percentage}%
                </div>
              )}
              <div
                className="position-absolute z-3"
                style={{
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#C93312",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                <img
                  src="../../../assets/images/BundleIcon-removebg-preview.png"
                  alt="bundle icon"
                  style={{
                    width: "25px",
                    height: "25px",
                    objectFit: "contain",
                    borderRadius: "50%",
                  }}
                />
              </div>
            </Link>
          ) : (
            <Link to={`/mockup?id=${item?.id}`} className="card-img-wrapper">
              <img
                src={thumbnailSrc}
                className="card-img-top rounded-tr-lg"
                alt="Product 1"
              />
              { saleInfo.active && saleInfo.percentage != null && !item?.is_free  && (
                <div
                  className="position-absolute z-3 text-center fw-bold text-white small"
                  style={{
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#C93312",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontSize: "12px",
                  }}
                >
                  Sale {saleInfo.percentage}%
                </div>
              )}
            </Link>
          )}

          {/* Star Rating at top left - only show for purchased mockups in MyMockups */}
          {/* {pageName === "myMockups" && 
           !item?.listings_count && 
           (item?.overall_rating !== undefined && item?.overall_rating !== null) && (
            <div
              className="position-absolute z-3"
              style={{
                top: "10px",
                left: "10px",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                borderRadius: "8px",
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <StarRating 
                rating={item?.overall_rating || 0} 
                readOnly={true} 
                size="small" 
              />
            </div>
          )} */}

          {/* 3-dot menu button at top right - only show for purchased mockups in MyMockups */}
          {pageName === "myMockups" &&
            !item?.listings_count &&
            (onAddReviewClick || showMoveToFolder || showRemoveFromFolder) && (
              <div
                ref={subMenuRef}
                className="position-absolute z-3"
                style={{
                  top: "10px",
                  left: "10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    color: "#333",
                    borderRadius: "8px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowSubMenu(!showSubMenu);
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0,0,0,0.25)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(0,0,0,0.15)";
                  }}
                >
                  <BsThreeDotsVertical size={20} />
                </div>

                {/* Submenu dropdown */}
                {showSubMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "42px",
                      left: "0",
                      backgroundColor: "white",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      minWidth: "160px",
                      zIndex: 1000,
                      overflow: "hidden",
                    }}
                  >
                    {onAddReviewClick && userid !== item?.user_id && !hasUserReviewed && (
                      <div
                        style={{
                          padding: "12px 16px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          borderBottom:
                            showMoveToFolder || showRemoveFromFolder
                              ? "1px solid #f0f0f0"
                              : "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onAddReviewClick(item?.id);
                          setShowSubMenu(false);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                            fill={hasUserReviewed ? "#C93312" : "#4CAF50"}
                          />
                        </svg>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {hasUserReviewed ? "Edit Review" : "Add Review"}
                        </span>
                      </div>
                    )}

                    {showMoveToFolder && onMoveToFolderClick && (
                      <div
                        style={{
                          padding: "12px 16px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onMoveToFolderClick(item?.id);
                          setShowSubMenu(false);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
                            fill="#C93312"
                          />
                        </svg>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Move to Folder
                        </span>
                      </div>
                    )}
                    {showRemoveFromFolder && onRemoveFromFolderClick && (
                      <div
                        style={{
                          padding: "12px 16px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onRemoveFromFolderClick(item?.id);
                          setShowSubMenu(false);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
                            fill="#C93312"
                          />
                        </svg>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Move Out
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
        </div>
        <div
          className="card-body text-center p-0 d-flex flex-column flex-grow-1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h5 className="card-title fw-bold text-start my-1 testelips  d-none d-lg-block">
              {title}
            </h5>

            <p className="card-title text-start mb-1 testelips d-lg-none">
              {title}
            </p>

            <p
              className="card-text text-start mb-1"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "14px",
                lineHeight: "1.45",
                marginTop: "8px",
                minHeight: "75px",
                fontWeight: "400",
                letterSpacing: "-0.1px",
                color: "#4A4A4A",
              }}
            >
              {description}
            </p>
          </div>
          <div className="d-none d-lg-block">
            {" "}
            <h2
              className="d-flex text-center fw-bold justify-content-center align-items-baseline flex-wrap"
              style={{ fontSize: "32px", marginTop: "16px" }}
            >
              <SalePriceLabel salePrice={salePrice} />
            </h2>
            <div className="listing-footer flex-wrap  d-flex gap-3 justify-content-center mb-2">
              {item?.listings_count ? (
                <>
                  {!item?.is_bought && !isAdmin ? (
                    <Link
                      to={`/bundle?id=${item?.id}`}
                      className="red-buy mt-2 mb-hidden"
                      variant="contained"
                      style={{ textTransform: "capitalize" }}
                    >
                      Buy
                    </Link>
                  ) : (
                    <button
                      onClick={() => {
                        // setBundleListingsById(item);
                        setBundleListingsId(item?.id);
                        // setShowBundleListings(true);
                      }}
                      className=" mb-hidden grey-use"
                    >
                      Open Bundle
                    </button>
                  )}
                </>
              ) : (
                <>
                  {!item.is_bought &&
                  !item?.is_free &&
                  pageName !== "myMockups" &&
                  !isAdmin ? (
                    <Link to={`/mockup?id=${item.id}`} className="red-buy mt-2">
                      Buy
                    </Link>
                  ) : (
                    <Link
                      to={`/mockup-editor?id=${item?.id}`}
                      className="grey-use mt-2"
                    >
                      Use
                    </Link>
                  )}
                </>
              )}
            </div>
            <div className="text-muted mt-2">
              By{" "}
              <Link
                to={`/browse-mockups?name=${item?.creator || item?.user_id}`}
                style={{ color: "#000" , overflow:"hidden" }}
              >
                {seller}
              </Link>
            </div>
          </div>
          <div className="d-lg-none d-flex flex-column justify-content-between align-items-center w-full">
            <h2
              className="d-flex fw-bold align-items-center flex-wrap"
              style={{ fontSize: "32px", marginTop: "16px" }}
            > 
              <SalePriceLabel salePrice={salePrice} />
            </h2>

          <div className="text-muted mt-2 text-center">
              By{" "}
              <Link
                to={`/browse-mockups?name=${item?.creator || item?.user_id}`}
                style={{ color: "#000" }}
              >
                {seller}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockupCard;
